import Home from "./components/Home";
import ZoomMeetingEnded from './components/common/ZoomMeetingEnded';
import ZoomAuthSuccess from './components/common/zoomAuthSuccess';
import ZoomMeetingLimit from './components/common/ZoomMeetingLimit';
import ZoomMeetingLogout from './components/common/zoomMeetingLogout';

const AppRoutes = [
    {
        index: true,
        element: <Home />
    },
    {
        path: '/end',
        element: <ZoomMeetingEnded />
    },
    {
        path: '/error',
        element: <ZoomMeetingLimit />
    },
    {
        path: '/log_out',
        element: <ZoomMeetingLogout />
    },
    {
        path: '/zoom_auth',
        element: <ZoomAuthSuccess />
    }
];

export default AppRoutes;
